// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__YG2_t","dragIcon":"SortableItem_dragIcon__2dsaz","disabled":"SortableItem_disabled__pcZdM"};